import { apiService, IApiResponse } from "../api/api.service";

class DeviceInfoService {
    async getData() {
        let result = await apiService.get("device/list", { pageIndex: 1, pageSize: 999999 });
        if (!apiService.generalProcessDataResponse(result)) return [];
        return result.data;
    }
}
export default new DeviceInfoService();